import { DeliveryMethodsTable } from '@/components/features/delivery-methods'

export const DeliveryMethods = () => {
  return (
    <div >
      <DeliveryMethodsTable />
    </div>
  )
}
